import {type DefaultError, useMutation} from "@tanstack/react-query";
import {queryHttp} from "../../../query/queryHttp";
import {environment} from "../../../env";
import {CHAT_CONFIG} from "../services/ChatConfiguration";

export type DeleteDashboardVariables = {
    dashboardId: number;
};

export type DeleteDashboardResponse = {
    message: string;
};

/**
 * `DELETE /api/v1/superset/dashboards/{dashboard_id}` — removes the dashboard
 * from the user's list only; the Superset dashboard itself is untouched.
 */
export function useDeleteDashboardMutation() {
    return useMutation<DeleteDashboardResponse, DefaultError, DeleteDashboardVariables>({
        mutationFn: async ({dashboardId}) => {
            if (environment.isTestChat) {
                return {message: "Test mode: delete dashboard skipped"};
            }
            if (!CHAT_CONFIG.API_URL) {
                throw new Error("Chat API URL is not configured");
            }
            const {data} = await queryHttp.request<DeleteDashboardResponse>({
                url: `${CHAT_CONFIG.API_URL}/superset/dashboards/${dashboardId}`,
                method: "DELETE",
            });
            return data;
        },
    });
}
